// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.loginView[data-v-78581254]
	{
		margin-top: auto;
		display: flex;
		flex-direction: column;
		align-items: center;
		width: 100%;
}
.loginLayout[data-v-78581254]
	{
		width: 100%;
		height: 100%;
		font-size: 16px;
		background-color: #555555;
		background-image: linear-gradient(120deg, #a1c4fd 0%, #c2e9fb 100%);
}
.loginLayout.style2[data-v-78581254]
		{
			background-image: linear-gradient(120deg, #84fab0 0%, #8fd3f4 100%);
}
.loginLayout.wallpaper[data-v-78581254]
		{
			background-size: cover;
			background-position: center;
}
.loginLayout.wallpaper .loginContainer[data-v-78581254]
			{
				backdrop-filter: blur(5px);
}
.loginContainer[data-v-78581254]
	{
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
		width: 100%;
		height: 100%;
}
.loginFooter[data-v-78581254]
	{
		background-color: rgba(255,255,255,0.5);
		backdrop-filter: blur(5px);
		box-shadow: 0 0 16px rgba(0,0,0,0.5);
		text-shadow: 0px 0px 4px rgba(255,255,255,1);
}
`, "",{"version":3,"sources":["webpack://./www/vues/login/LoginLayout.vue"],"names":[],"mappings":";AAmCC;;EAEC,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACZ;AAEA;;EAEC,WAAW;EACX,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,mEAAmE;AACpE;AAEC;;GAEC,mEAAmE;AACpE;AAEA;;GAEC,sBAAsB;GACtB,2BAA2B;AAC5B;AAEC;;IAEC,0BAA0B;AAC3B;AAEF;;EAEC,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,YAAY;AACb;AAEA;;EAEC,uCAAuC;EACvC,0BAA0B;EAC1B,oCAAoC;EACpC,4CAA4C;AAC7C","sourcesContent":["<template>\r\n\t<div :class=\"loginLayoutClasses\">\r\n\t\t<div class=\"loginContainer\">\r\n\t\t\t<router-view class=\"loginView\"></router-view>\r\n\t\t\t<Footer class=\"loginFooter\" />\r\n\t\t\t<VStyle>\r\n\t\t\t\t.loginLayout.wallpaper\r\n\t\t\t\t{\r\n\t\t\t\tbackground-image: url('{{appPath}}images/long-hallway-with-row-servers-center-10.webp');\r\n\t\t\t\t}\r\n\t\t\t</VStyle>\r\n\t\t</div>\r\n\t</div>\r\n</template>\r\n<script>\r\n\timport Footer from 'appRoot/vues/common/Footer.vue';\r\n\timport VStyle from 'appRoot/vues/common/controls/VStyle.vue';\r\n\r\n\texport default {\r\n\t\tcomponents: { VStyle, Footer },\r\n\t\tdata()\r\n\t\t{\r\n\t\t\treturn {\r\n\t\t\t\tappPath: appContext.appPath,\r\n\t\t\t\tloginLayoutClasses: [\"loginLayout\"]\r\n\t\t\t};\r\n\t\t},\r\n\t\tcreated()\r\n\t\t{\r\n\t\t\tif (appContext.loginStyle)\r\n\t\t\t\tthis.loginLayoutClasses.push(appContext.loginStyle);\r\n\t\t}\r\n\t}\r\n</script>\r\n<style scoped>\r\n\t.loginView\r\n\t{\r\n\t\tmargin-top: auto;\r\n\t\tdisplay: flex;\r\n\t\tflex-direction: column;\r\n\t\talign-items: center;\r\n\t\twidth: 100%;\r\n\t}\r\n\r\n\t.loginLayout\r\n\t{\r\n\t\twidth: 100%;\r\n\t\theight: 100%;\r\n\t\tfont-size: 16px;\r\n\t\tbackground-color: #555555;\r\n\t\tbackground-image: linear-gradient(120deg, #a1c4fd 0%, #c2e9fb 100%);\r\n\t}\r\n\r\n\t\t.loginLayout.style2\r\n\t\t{\r\n\t\t\tbackground-image: linear-gradient(120deg, #84fab0 0%, #8fd3f4 100%);\r\n\t\t}\r\n\r\n\t\t.loginLayout.wallpaper\r\n\t\t{\r\n\t\t\tbackground-size: cover;\r\n\t\t\tbackground-position: center;\r\n\t\t}\r\n\r\n\t\t\t.loginLayout.wallpaper .loginContainer\r\n\t\t\t{\r\n\t\t\t\tbackdrop-filter: blur(5px);\r\n\t\t\t}\r\n\r\n\t.loginContainer\r\n\t{\r\n\t\tdisplay: flex;\r\n\t\tflex-direction: column;\r\n\t\tjustify-content: space-between;\r\n\t\talign-items: center;\r\n\t\twidth: 100%;\r\n\t\theight: 100%;\r\n\t}\r\n\r\n\t.loginFooter\r\n\t{\r\n\t\tbackground-color: rgba(255,255,255,0.5);\r\n\t\tbackdrop-filter: blur(5px);\r\n\t\tbox-shadow: 0 0 16px rgba(0,0,0,0.5);\r\n\t\ttext-shadow: 0px 0px 4px rgba(255,255,255,1);\r\n\t}\r\n</style>\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
